import gql from 'graphql-tag';

export const UPSERT_VENDOR_OPPORTUNITY_REVENUE = gql`
  mutation UpsertVendorOpportunityRevenue($input: UpsertVendorOpportunityRevenueInput!) {
    result: upsertVendorOpportunityRevenue(input: $input) {
      id
    }
  }
`;
